import { render, staticRenderFns } from "./WidthDrawRecord.vue?vue&type=template&id=76c122b0"
import script from "./WidthDrawRecord.vue?vue&type=script&lang=js"
export * from "./WidthDrawRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports